import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { importCsvTypeInsert, importCsvTypeUpdate, importEmployeeFromCsv } from '@/apis/employees'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { ImportEmployeeFromCsvRequest, ImportEmployeeFromCsvResponse } from '@/types/apis/employees'

export const useImportEmployee = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<ImportEmployeeFromCsvResponse>()

  const imp = useCallback(
    async (request: ImportEmployeeFromCsvRequest) => {
      try {
        setLoading(true)
        const res = await importEmployeeFromCsv(request)
        setResponse(res)
        openNotification({ description: t('pages.employees.importFromCsv.importSuccessfully') })
        navigate(routes.employees.path)
      } catch (error) {
        openNotification({ description: t('pages.employees.importFromCsv.importFailed'), type: 'error' })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  const importEmployeeTypeInsert = useCallback(
    async (request: ImportEmployeeFromCsvRequest) => {
      try {
        setLoading(true)
        const res = await importCsvTypeInsert(request)
        setResponse(res)
        openNotification({ description: t('pages.employees.importFromCsv.importSuccessfully') })
        navigate(routes.employees.path)
      } catch (error) {
        openNotification({ description: t('pages.employees.importFromCsv.importFailed'), type: 'error' })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  const importEmployeeTypeUpdate = useCallback(
    async (request: ImportEmployeeFromCsvRequest) => {
      try {
        setLoading(true)
        const res = await importCsvTypeUpdate(request)
        setResponse(res)
        openNotification({ description: t('pages.employees.importFromCsv.importSuccessfully') })
        navigate(routes.employees.path)
      } catch (error) {
        openNotification({ description: t('pages.employees.importFromCsv.importFailed'), type: 'error' })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    importEmployee: imp,
    importEmployeeTypeInsert,
    importEmployeeTypeUpdate,
    response,
  }
}
